// @lumi/app-kit shared i18n vocabulary (ADR 0026 §7) — locale nl.
// Byte-identical common.*/errors.* used across >=3 apps + owned by app-kit components.
// Apps merge appKitMessages under their own catalog; the no-shadow check forbids an
// app from redefining these keys. Generated from the per-app catalogs.
export default {
  // The sidebar's account menu + history buttons (suite design foundation, spec §4):
  // byte-identical across every chrome, so owned here rather than by nine app catalogs.
  accountMenu: {
    profile: 'Mijn profiel',
    settings: 'Instellingen',
    theme: 'Weergave',
    themeLight: 'Licht',
    themeDark: 'Donker',
    support: 'Support',
    back: 'Terug',
    forward: 'Vooruit',
    collapseSidebar: 'Zijbalk inklappen',
    expandSidebar: 'Zijbalk uitklappen',
    // The account row of a phone-only account (issue 698): no name, no address.
    signedIn: 'Ingelogd',
  },
  // A sidebar entry another of the viewer's own roles opens (#1028): the
  // greyed entry's hint, its switch dialog, and the role list joiner.
  roleLock: {
    hint: 'Alleen als {roles}. Rol wisselen: linksonder via je account → Rol.',
    body: 'Dit onderdeel heb je als {roles}. Nu werk je als {active}.',
    action: 'Openen als {role}',
    where: 'Je kunt je rol altijd wisselen: linksonder via je account → Rol.',
    listOr: '{list} of {last}',
  },
  common: {
    // Every DateField's calendar and typing hint (issue 823; People's own until then).
    datePicker: {
      open: 'Kalender openen',
      previousMonth: 'Vorige maand',
      nextMonth: 'Volgende maand',
      month: 'Maand',
      year: 'Jaar',
      clear: 'Datum wissen',
      dayToken: 'DD',
      monthToken: 'MM',
      yearToken: 'JJJJ',
    },
    deactivate: 'Deactiveren',
    revoke: 'Intrekken',
    remove: 'Verwijderen',
    actions: 'Acties',
    calendar: 'Kalender',
    cancel: 'Annuleren',
    close: 'Sluiten',
    confirmTitle: 'Bevestigen',
    contactSupport: 'Contact opnemen met support',
    copyLink: 'Link kopiëren',
    edit: 'Bewerken',
    language: 'Taal',
    linkCopied: 'Link gekopieerd',
    linkCopyFailed: 'Kon link niet kopiëren',
    moduleListHeading: 'Jouw modules',
    moduleTeaserAction: 'Toevoegen in facturering',
    moduleTeaserHeading: 'Ook onderdeel van lumi',
    moduleTeaserNote: 'De workspace-eigenaar, de admins en de Billing Managers kunnen deze modules toevoegen.',
    moduleTeaserTag: 'Niet in je abonnement',
    no: 'Nee',
    nothingHere: 'Hier is nog niets',
    ok: 'OK',
    refresh: 'Vernieuwen',
    retry: 'Opnieuw proberen',
    role: 'Rol',
    save: 'Opslaan',
    search: 'Zoeken',
    switchModule: 'Module wisselen',
    tabsNext: 'Volgende tabbladen tonen',
    tabsPrevious: 'Vorige tabbladen tonen',
    understood: 'Begrepen',
    userDeactivated: '{name} (gedeactiveerd)',
    yes: 'Ja',
  },
  errors: {
    // ADR 0036 code-first branch (errorKeyFor): a backend `code` wins over the
    // status. `invalid_credentials` is what every login door answers a bad
    // sign-in with — a bare 401 would otherwise fall through to
    // `errors.unauthorized`, telling someone who mistyped their password that
    // their session expired (issue 364, F10). It never lets a caller tell an
    // unknown account apart from a mistyped password — the two answer
    // identically — so the copy names both fields.
    // `MASTER_INVITE_REJECTED` is people-api's fallback when the identity
    // service refuses an invitation payload without a code of its own (issue
    // 364, decisions round 1): without an entry here it degrades to the
    // status-derived message, which says nothing about what to look at. Its
    // sibling `MASTER_TENANT_NOT_FOUND` stays local to PersonDetailView on
    // purpose — that one names a next step specific to that screen.
    codes: {
      invalid_credentials: 'Inloggen mislukt. Controleer je e-mailadres en je wachtwoord.',
      MASTER_INVITE_REJECTED: 'Deze uitnodiging is geweigerd omdat de gegevens van de persoon niet konden worden geaccepteerd. Controleer het e-mailadres en de naam in het persoonsdossier en probeer het opnieuw.',
      PERSON_EMAIL_INVALID: 'Voor deze persoon ontbreekt een geldig e-mailadres, dus er kan geen login worden uitgenodigd. Corrigeer eerst het adres in het persoonsdossier.',
      PERSON_PHONE_INVALID: 'Dit mobiele nummer is niet geldig. Vul het in internationaal formaat in, met + en de landcode, bijv. +31 6 12345678.',
      PERSON_ACCESS_PHONE_TAKEN: 'Een andere persoon heeft al een login met dit mobiele nummer, of krijgt er een. Eén nummer, één persoon.',
      PHONE_ACCESS_UNAVAILABLE: 'Toegang via mobiel nummer is hier niet beschikbaar — voor deze workspace of voor het land van dit nummer. Gebruik in plaats daarvan een e-mailadres.',
      SUITE_ROLE_NEEDS_EMAIL: 'Deze persoon logt in met een mobiel nummer en heeft geen e-mailadres. Suiterollen krijgen juridische, factuur- en toestemmingsmails en hebben daarom een adres nodig.',
      OWNER_NEEDS_EMAIL: 'Deze persoon logt in met een mobiel nummer en heeft geen e-mailadres. De eigenaar krijgt juridische en contractmails, dus eigenaarschap heeft een adres nodig.',
      RECORD_CHANGED: 'Iemand anders heeft dit record gewijzigd terwijl je het bewerkte. Laad het opnieuw – je invoer blijft bewaard als concept.',
    },
    appUpdatedBody: 'Deze pagina kon niet volledig worden geladen omdat de app is bijgewerkt. Herlaad om verder te gaan.',
    appUpdatedTitle: 'Er is een nieuwe versie beschikbaar',
    conflict: 'Deze actie is in conflict met de huidige status. Herlaad en probeer opnieuw.',
    contactSupport: 'Contact opnemen met support',
    exhausted: 'Dit lijkt echt kapot. Het spijt ons. Neem contact op met support.',
    failedTitle: 'Actie mislukt',
    forbidden: 'Je hebt geen toestemming voor deze actie.',
    loadFailedTitle: 'Kon niet worden geladen',
    network: 'Geen verbinding met de server. Controleer je internetverbinding.',
    notFound: 'Het gevraagde item is niet gevonden.',
    rateLimited: 'Te veel verzoeken. Wacht even en probeer opnieuw.',
    recordChangedReload: 'Iemand anders heeft dit record opgeslagen nadat je het opende, dus je wijziging is niet doorgevoerd. Laad opnieuw om de huidige versie te zien – je invoer blijft bewaard en kan worden hersteld.',
    refreshFailedTitle: 'Dit is mogelijk niet meer actueel',
    server: 'Er is een serverfout opgetreden. Probeer het later opnieuw.',
    timeout: 'De server heeft niet op tijd geantwoord. Probeer het zo meteen opnieuw.',
    unauthorized: 'Je sessie is verlopen. Meld je opnieuw aan.',
    unexpected: 'Er ging iets mis bij het weergeven hiervan. Probeer het opnieuw.',
    validation: 'Controleer je invoer.',
  },
  notReady: {
    title: 'Dit is nog niet klaar voor jou',
    body: 'Je werkruimte wordt nog voorbereid. We brengen je over 5 seconden terug naar de workspace.',
  },
  // The workspace this app was opened on does not exist, or can no longer be
  // reached (issue 364, F57). ONE message for BOTH causes on purpose: ats-api
  // answers a suspended tenant and an unknown slug identically, and splitting
  // the copy would confirm which workspaces exist. `body` therefore names no
  // cause, and nothing on the page names a workspace, a slug or a person.
  tenantUnavailable: {
    title: 'Deze werkruimte is niet bereikbaar',
    body: 'Deze werkruimte bestaat niet of is op dit moment niet bereikbaar — controleer het adres dat je hebt geopend.',
    accountLead: 'Je eigen gegevens en je facturen blijven beschikbaar in je lumi-account.',
    accountCta: 'Naar je lumi-account',
    supportLead: 'Klopt dit niet? Neem contact op, dan lossen we het samen op.',
    // The signed-in person's own membership is gone (issue 669): a revoked demo guest,
    // or a demo that ended under an open tab.
    ended: {
      title: 'Je hebt geen toegang tot deze werkruimte',
      body: 'Je bent ingelogd, maar je bent geen lid (meer) van deze werkruimte. Als je gast was in een demo, is de demo beëindigd of is je uitnodiging ingetrokken.',
      accountLead: 'Je eigen lumi-account blijft ongemoeid.',
    },
  },
  billing: {
    banner: {
      suspendedTitle: 'Werkruimte vergrendeld',
      suspendedMessage: 'Deze werkruimte is opgeschort. Neem contact met ons op om de toegang te herstellen.',
      lockedBody: 'Deze werkruimte is vergrendeld vanwege een openstaand factureringsprobleem. De toegang tot alle modules is momenteel gepauzeerd.',
      lockedSupportLead: 'Neem contact op met ons supportteam om de toegang te herstellen:',
      lockedSupportCta: 'Contact opnemen met support',
      lockoutOn: 'Anders wordt hij op {date} vergrendeld.',
      fixCardTitle: 'Werk je kaart bij',
      fixCardBody: 'Je laatste betaling is geweigerd omdat je kaart niet werd geaccepteerd.',
      fixCardCta: 'Kaart bijwerken',
      softDeclineTitle: 'Zorg dat je betaling lukt',
      softDeclineBody: 'We konden je laatste betaling niet innen en proberen het automatisch opnieuw. Zorg dat je betaalmethode voldoende saldo heeft.',
      softDeclineCta: 'Betaalmethode controleren',
      scaTitle: 'Bevestig je betaling',
      scaBody: 'Je bank moet deze betaling bevestigen voordat we hem kunnen innen.',
      scaCta: 'Betaling bevestigen',
      recoveryError: 'De betaling kon nu niet worden gestart. Probeer het zo meteen nog eens.',
      chargebackTitle: 'Voldoe je teruggeboekte betaling',
      chargebackBody: 'Je bank heeft een betaling teruggeboekt, waardoor die weer openstaat. Voeg een betaalmethode toe om die te voldoen.',
      chargebackCta: 'Betaalmethode toevoegen',
      trialTitle: 'Voeg een betaalmethode toe',
      trialBody: 'Je proefperiode is afgelopen. Voeg een betaalmethode toe om deze werkruimte actief te houden.',
      trialCta: 'Betaalmethode toevoegen',
      reviewTitle: 'Controleer je facturering',
      reviewBody: 'Deze werkruimte vereist een factureringsactie om actief te blijven.',
      reviewCta: 'Facturering beheren',
      contactTitle: 'Neem contact op met je beheerder',
      contactBody: 'Een factureringsprobleem vereist aandacht om deze werkruimte actief te houden.',
    },
  },
  legalNoticeBanner: {
    title: 'Juridische kennisgevingen hebben je aandacht nodig',
    employeeBody: 'Uitnodigingen zijn gepauzeerd totdat de privacykennisgeving voor medewerkers compleet is.',
    candidateBody: 'Het carrièreportaal is offline totdat de kennisgevingen voor sollicitanten compleet zijn.',
    imprintBody: 'Het carrièreportaal is offline totdat er een colofon is opgeslagen.',
    candidateImprintBody: 'Het carrièreportaal is offline totdat de kennisgevingen voor sollicitanten compleet zijn en er een colofon is opgeslagen.',
    cta: 'Juridische kennisgevingen openen',
  },
  // The one "needs you" strip (issue 713): the list label, the hide control and the
  // per-item sentences. A lone legal item reuses legalNoticeBanner.* word for word.
  needsYou: {
    label: 'Heeft je nog nodig:',
    hide: 'Verbergen',
    timeRules: {
      link: 'Arbeidstijdenregels',
      cta: 'Controleren',
      body: 'De arbeidstijdenregels zijn nog niet gecontroleerd. lumi rekent met de wettelijke standaardregels en waarschuwt alleen tot iemand bevestigt dat ze bij jullie bedrijf passen.',
    },
    legal: { link: 'Juridische mededelingen invullen' },
    billing: {
      link: 'Facturatie voltooien',
      cta: 'Facturatie openen',
      bodyBoth: 'Voeg je factuurgegevens en een betaalmethode toe, zodat je werkruimte zonder onderbreking blijft werken.',
      bodyInvoiceDetails: 'Voeg je factuurgegevens toe, zodat je facturen correct worden uitgegeven.',
      bodyPaymentMethod: 'Voeg een betaalmethode toe, zodat je werkruimte zonder onderbreking blijft werken.',
    },
  },
  // Consented temporary support access (ADR 0041): the marker every module
  // chrome shows beside the tenant name while a supporter is inside a grant.
  supportAccess: {
    label: 'Supporttoegang',
    until: 'Tijdelijke supporttoegang tot {until} — alles wat u hier doet, staat in het auditlog van deze tenant.',
  },
  // Idle session timeout (issue 265). Owned by app-kit's IdleLogoutGuard, except
  // idleSignedOut — the login pages (workspace, system-admin) render that after
  // the bounce, and it is the same suite-wide policy statement, so it stays in one
  // place rather than drifting between the two login surfaces.
  session: {
    idleTitle: 'Ben je er nog?',
    idleBody: 'Je bent al een tijdje inactief. Voor je veiligheid melden we je automatisch af.',
    idleStay: 'Aangemeld blijven',
    idleSignedOut: 'Je bent na {minutes} minuten inactiviteit afgemeld. Meld je opnieuw aan.',
  },
  // Browser form drafts (owner-stamped, 7 days, typed values only — app-kit
  // utils/formDraftStorage.ts). Owned by app-kit's DraftBanner and by the
  // sign-out warning every module chrome shows, so the wording lives here instead
  // of drifting across five app catalogs.
  formDrafts: {
    bannerTitle: 'Niet-opgeslagen concept',
    bannerSavedAt: 'Opgeslagen op dit apparaat: {when}',
    bannerRecordChanged: 'Het record is gewijzigd sinds dit concept. Herstellen zet alleen de velden terug die jij hebt gewijzigd.',
    restore: 'Herstellen',
    discard: 'Verwijderen',
    closeTitle: 'Invoer in ‘{form}’ verwerpen?',
    closeBody: 'Niet-opgeslagen invoer gaat verloren.',
    closeConfirm: 'Verwerpen',
    closeCancel: 'Verder bewerken',
    recordChangedTitle: 'Gewijzigd door iemand anders',
    reload: 'Opnieuw laden',
    forms: {
      'apprentice': {
        planStation: 'Opleidingsplan-station',
        skillCatalogue: 'Vaardighedencatalogus',
        trainingData: 'Opleidingsgegevens',
      },
      'ats': {
        workflowEditor: 'Workfloweditor',
      },
      'backoffice': {
        applicationForm: 'Sollicitatie',
        createApplication: 'Nieuwe sollicitatie',
        customField: 'Aangepast veld',
        customFields: 'Aangepaste velden',
        emailSettings: 'E-mailinstellingen',
        jobAd: 'Vacature',
        jobAdTemplate: 'Vacaturesjabloon',
        jobEdit: 'Vacature',
        portalSettings: 'Instellingen carrièreportaal',
        ravenBatchPublish: 'Bulk-vacaturepublicatie',
        ravenPublish: 'Vacaturepublicatie',
        role: 'Rol',
        suggestion: 'Suggestie',
        supportTicket: 'Ondersteuningsticket',
        supportTicketReply: 'Antwoord op ondersteuningsticket',
        talentEdit: 'Talentprofiel',
        workflowAction: 'Workflowactie',
        workflowCondition: 'Workflowvoorwaarde',
        workflowGuard: 'Workflowbeveiliging',
        workflowState: 'Workflowstatus',
        workflowTransition: 'Workflowovergang',
      },
      'people': {
        bankAccount: 'Bankrekening',
        companyProfile: 'Bedrijfsprofiel',
        employmentContract: 'Arbeidsovereenkomst',
        myProfile: 'Mijn profiel',
        onboardingTemplate: 'Onboardingsjabloon',
        oneTimePayment: 'Eenmalige betaling',
        orgUnit: 'Organisatie-eenheid',
        person: 'Persoon',
        taxProfile: 'Belastingprofiel',
        wageAssignment: 'Loonbeslag',
      },
      'system-admin': {
        fileQuota: 'Bestandsquotum',
        skillDetail: 'Vaardigheidsdetail',
        suggestionNotes: 'Notities bij suggestie',
      },
      'time': {
        blueprint: 'Werktijdmodel',
        leaveRequest: 'Verlofaanvraag',
        leaveType: 'Afwezigheidstype',
        orgGroup: 'Organisatiegroep',
        project: 'Project',
        role: 'Rol',
        userProfile: 'Gebruikersprofiel',
        weekGrid: 'Weekrooster',
        workTimeModel: 'Werktijdmodel',
      },
      'user': {
        ssoSettings: 'SSO-instellingen',
      },
      'workspace': {
        billingProfile: 'Factuurprofiel',
        wizardGeneral: 'Installatiewizard',
      },
    },
  },
  // Suite-wide legal footer (issue 221): the § 5 DDG imprint and the privacy
  // notice of the Lumi entity live once on the marketing site, and every app
  // links to them through the shared LegalLinksFooter. The wording is
  // byte-identical everywhere, so it belongs to app-kit rather than to any app.
  legal: {
    imprint: 'Colofon',
    privacy: 'Privacy',
    terms: 'Algemene voorwaarden',
    label: 'Juridische informatie',
    employeeNotice: 'Privacy bij {company}',
  },
  dataImport: {
    run: {
      stepsLabel: 'Stappen van de import',
      steps: {
        file: 'Bestand',
        questions: 'Vragen',
        review: 'Controleren',
        commit: 'Overnemen',
      },
      toOverview: 'Naar het overzicht',
      reading: '{file} wordt gelezen',
      checking: 'Rijen worden gecontroleerd',
      committing: 'Gegevens worden overgenomen',
      tables: '{count} tabel | {count} tabellen',
      rows: '{count} rij | {count} rijen',
      aiOn: 'Lumi verbetert de toewijzing',
      aiOff: 'Toewijzing volgens regels',
      proposalByRules: 'Voorstel volgens regels · {reason}',
      reasons: {
        off: 'Lumi stond voor dit bestand uit.',
        disabled: 'AI staat uit in deze werkruimte.',
        quota: 'Het AI-tegoed was op.',
        no_key: 'Er is geen AI-sleutel ingesteld.',
        error: 'Lumi was zojuist niet bereikbaar.',
      },
    },
    title: 'Data-import',
    intro: 'Importeer bestaande gegevens uit een oud systeem: upload een bestand, controleer de veldtoewijzing, bekijk de proefrun en neem daarna over.',
    backToList: 'Terug naar overzicht',
    sourceSystem: 'Bronsysteem',
    cancelled: 'Deze import is geannuleerd.',
    steps: {
      upload: 'Uploaden',
      analysis: 'Analyse',
      mapping: 'Toewijzing',
      dryRun: 'Proefrun',
      commit: 'Overname',
    },
    status: {
      uploaded: 'Geüpload',
      analyzing: 'Wordt geanalyseerd',
      mapping_ready: 'Toewijzing controleren',
      dry_running: 'Proefrun loopt',
      dry_run_ready: 'Proefrun klaar',
      committing: 'Wordt overgenomen',
      completed: 'Afgerond',
      failed: 'Mislukt',
      cancelled: 'Geannuleerd',
    },
    formats: {
      csv: 'CSV',
      xlsx: 'Excel',
      json: 'JSON',
      sql_dump: 'SQL-dump',
      hropen: 'HR Open JSON',
    },
    transforms: {
      none: 'Direct',
      date: 'Datum',
      number: 'Getal',
      boolean: 'Ja/Nee',
      enum_map: 'Waardetoewijzing',
      split_name: 'Naam splitsen',
      concat: 'Samenvoegen',
      const: 'Constante',
      skip: 'Negeren',
    },
    upload: {
      sourceSystem: 'Naam van het bronsysteem',
      sourceSystemHint: 'Wordt als referentie opgeslagen zodat opnieuw importeren records bijwerkt in plaats van dupliceert.',
      sourceSystemPlaceholder: 'bijv. oud_hr_systeem',
      sourceSystemFirst: 'Geef eerst het bronsysteem een naam.',
      dropHint: 'Sleep een bestand hierheen of blader',
      formats: 'CSV, Excel (XLSX), JSON of SQL-dump — max. 50 MB',
      browse: 'Bestand kiezen',
      uploading: 'Uploaden …',
    },
    running: {
      uploaded: 'Analyse wordt gestart …',
      analyzing: 'Bestand wordt geanalyseerd …',
      dry_running: 'Proefrun loopt …',
      committing: 'Gegevens worden overgenomen …',
      hint: 'Grote bestanden kunnen enkele minuten duren. Deze pagina ververst automatisch.',
    },
    failed: {
      title: 'Import mislukt',
      generic: 'Het bestand kon niet worden gelezen.',
      unsupported: 'Dit bestandsformaat wordt niet ondersteund. Gebruik CSV, Excel, JSON, een SQL-dump of HR Open.',
      empty: 'Het bestand bevat geen enkele rij.',
      enqueue: 'De import kon niet worden gestart. Probeer het zo nog eens.',
      dryRun: 'De rijen konden niet worden gecontroleerd. Begin met het bestand opnieuw vanuit het overzicht.',
      commit: 'De gegevens konden niet worden overgenomen. Begin met het bestand opnieuw vanuit het overzicht.',
    },
    questions: {
      quoted: '„{value}”',
      saving: 'De koppeling wordt opgeslagen',
      companionRunning: '{entity} worden aangemaakt in {module}',
      reading: {
        title: 'Dit hebben we herkend',
        taken: 'Wordt overgenomen',
        notTaken: 'Wordt niet overgenomen',
        from: 'uit kolom',
        nothingTaken: 'Uit dit bestand wordt nog niets overgenomen.',
        split: '(gesplitst)',
        joined: '(samengevoegd)',
        reasons: {
          other_entry: 'hoort bij een ander onderdeel',
          never_importable: 'wordt nooit geïmporteerd',
          no_field: 'geen passend veld',
        },
        wrong: 'Klopt er iets niet?',
        editMapping: 'Koppeling per kolom wijzigen',
        improve: 'Laat Lumi het verbeteren',
        improveConflict: 'Het bestand kan nu niet opnieuw worden gelezen. Laad de pagina opnieuw en probeer het nog eens.',
      },
      extras: {
        title: 'Het bestand bevat ook andere gegevens. Moeten die ook worden overgenomen?',
        columns: 'Uit {columns}.',
        companion: 'Uit {columns}: {count} nieuwe waarde, die in {module} wordt aangemaakt voordat de rest van de gegevens komt. | Uit {columns}: {count} nieuwe waarden, die in {module} worden aangemaakt voordat de rest van de gegevens komt.',
        companionTruncated: 'Uit {columns}: minstens {count} nieuwe waarde, die in {module} wordt aangemaakt voordat de rest van de gegevens komt. | Uit {columns}: minstens {count} nieuwe waarden, die in {module} worden aangemaakt voordat de rest van de gegevens komt.',
        asOwnEntry: 'Wat meekomt, verschijnt in de migratie als een eigen onderdeel (uit {file}).',
        forbidden: 'Je hebt hiervoor geen rechten in {module}. De import gaat zonder deze gegevens verder.',
        unavailable: '{module} antwoordde zonet niet. De import gaat zonder deze gegevens verder.',
      },
      list: {
        heading: 'We hoeven je niets meer te vragen | We moeten je één ding vragen | We moeten je {count} dingen vragen',
      },
      uncertain: {
        title: 'De kolom {column} bevat {samples} — is dat {field}?',
        titleNoSamples: 'De kolom {column} — is dat {field}?',
        yes: 'Ja, dat is {field}',
        no: 'Nee, het is …',
        pickField: 'Kies een veld',
        skip: 'Niet overnemen',
      },
      required: {
        title: 'Voor {entity} hebben we {field} nodig. Waar komt het vandaan?',
        forAll: 'Voor iedereen hetzelfde:',
        pickValue: 'Kies een waarde',
        inColumn: 'Staat in kolom …',
        pickColumn: 'Kies een kolom',
        none: 'Het bestand heeft dit niet',
      },
      supervisor: {
        title: 'Wie is de leidinggevende van deze mensen?',
        fromColumn: 'Uit de kolom',
        columnHint: 'Het personeelsnummer moet in dit bestand staan of al in Personeel bestaan.',
        onePerson: 'Eén persoon voor iedereen:',
        pickPerson: 'Kies een persoon',
        noPersons: 'Eén persoon voor iedereen kun je niet kiezen: de lijst met personen is hier niet beschikbaar voor jou.',
        self: 'Iedereen leidt voorlopig zichzelf',
        selfHint: 'Het organigram bouw je daarna op in Personeel.',
        deferred: 'Voorlopig zonder leidinggevende',
        deferredHint: 'Rijen zonder leidinggevende markeren we bij het controleren.',
        personsTruncated: 'De eerste 500 personen op naam; het personeelsnummer van de gezochte persoon kun je ook via een kolom opgeven.',
      },
      enum: {
        title: 'In {column} staan waarden die {module} niet kent',
        count: '{count}×',
        pick: 'Kies een optie',
        leaveEmpty: 'leeg laten',
        rowLabel: 'Koppeling voor {value}',
        viaCompanion: 'wordt aangemaakt in {module}',
      },
      date: {
        title: 'Hoe is de datum in {column} opgebouwd?',
        day: 'dag',
        month: 'maand',
        year: 'jaar',
        yearShort: 'jaar (2 cijfers)',
        example: '{sample} wordt gelezen als {date}',
      },
      fold: {
        title: 'Alle koppelingen per kolom ({count} kolom) | Alle koppelingen per kolom ({count} kolommen)',
        show: 'Tonen',
        hide: 'Verbergen',
      },
      verdict: {
        title: 'Dit bestand kan geen {entry} worden',
        missing: 'Er ontbreekt: {fields}. Geen enkele kolom van het bestand komt daarvoor in aanmerking.',
        extraHint: 'Als je de extra gegevens hierboven uitzet, vervalt dit.',
        elsewhere: 'Kies een ander onderdeel:',
        readAs: 'Lezen als {entry}',
        otherModule: 'Hoort het bestand in een andere module, verwerp het dan hier en leg het neer waar het thuishoort.',
        discard: 'Bestand verwerpen',
      },
      footer: {
        next: 'Hierna controleren we elke rij. Er wordt nog niets opgeslagen.',
        nextCreating: 'Eerst maken we {count} nieuwe waarde ({what}) aan in {module}, daarna controleren we elke rij van je bestand. | Eerst maken we {count} nieuwe waarden ({what}) aan in {module}, daarna controleren we elke rij van je bestand.',
        back: 'Terug',
        confirm: 'Volgende: gegevens controleren',
        confirmCreating: 'Volgende: aanmaken en controleren',
        open: 'Nog één vraag open | Nog {count} vragen open',
        withoutThem: 'Je kunt zonder deze gegevens doorgaan.',
      },
    },
    mapping: {
      hint: 'Controleer de voorgestelde toewijzing: per tabel een doel, per kolom een veld. Gemarkeerde rijen zijn onzekere voorstellen.',
      targetEntity: 'Doel',
      skipTable: 'Niet importeren',
      skippedTable: 'Deze tabel wordt niet geïmporteerd.',
      ignoreColumn: 'Negeren',
      sourceColumn: 'Kolom',
      sample: 'Voorbeeldwaarden',
      targetField: 'Doelveld',
      transform: 'Transformatie',
      preview: 'Voorbeeld',
      rowCount: '{count} rijen',
      patternHint: 'Datumpatroon, bijv. DD.MM.YYYY',
      multiTargetHint: 'Doel {index} van {total} — hetzelfde bestand vult meerdere doelen',
      valueMap: 'Waarden toewijzen',
      valueMapHint: 'Wijs de bronwaarden toe aan de in het systeem toegestane waarden. Niet-toegewezen waarden geven per rij een fout in de proefrun. Gebaseerd op maximaal 20 verschillende voorbeeldwaarden van de kolom.',
      valueMapUnmapped: '— niet toegewezen —',
      addColumnRow: 'Kolom nogmaals toewijzen',
      customFieldBadge: 'Eigen veld',
      createCustomField: 'Nieuw eigen veld aanmaken…',
      confirm: 'Toewijzing bevestigen & proefrun starten',
    },
    report: {
      dryRunHint: 'Proefrun — er is nog niets geschreven. Controleer de aantallen en fouten voordat je overneemt.',
      completedHint: 'Import afgerond. De gegevens zijn overgenomen.',
      created: 'Nieuw',
      updated: 'Bijgewerkt',
      skipped: 'Overgeslagen',
      errors: 'Fouten',
      errorList: '{count} fouten',
      downloadErrors: 'Alle fouten downloaden',
      row: 'Rij',
      errorMessage: 'Melding',
      backToMapping: 'Terug naar toewijzing',
      commit: 'Gegevens overnemen',
      commitConfirmTitle: 'Gegevens overnemen?',
      commitConfirmBody: 'De import schrijft nu naar deze module. Nieuwe records worden aangemaakt, bestaande bijgewerkt. Dit kan niet automatisch ongedaan worden gemaakt.',
      commitStarted: 'Overname gestart – de gegevens worden weggeschreven.',
    },
    review: {
      title: 'Dit komt in het systeem. Wil je nog iets aanpassen?',
      filterLabel: 'Rijen filteren',
      note: 'Wijzigingen gelden alleen voor deze import. Je bestand blijft zoals het is.',
      row: 'Rij',
      status: 'Status',
      choose: 'Kiezen …',
      yes: 'Ja',
      no: 'Nee',
      noRows: 'Geen rijen voor deze selectie.',
      rowsNoun: 'Rijen',
      tiles: {
        new: 'Nieuw',
        updated: 'Bijgewerkt',
        toClear: 'Uit te zoeken',
        newNote: '{things} worden aangemaakt',
        updatedNote: 'bestaan al, ontbrekende velden worden aangevuld',
        toClearNote: 'blijven anders buiten',
      },
      leftOut: '{count} rij weggelaten | {count} rijen weggelaten',
      filter: {
        all: 'Alle',
        skipped: 'Weggelaten',
      },
      statuses: {
        new: 'nieuw',
        updated: 'bijgewerkt',
        open: 'open',
        corrected: 'gecorrigeerd',
        skipped: 'weggelaten',
      },
      fixField: '{field} in rij {row} aanpassen',
      reasonOf: 'Waarom rij {row} open is',
      popoverLabel: 'Rij {row}: wat er niet klopt',
      mean: 'Bedoelde je {value}?',
      accept: '{value} overnemen',
      findPerson: 'Persoon zoeken …',
      pickPerson: 'Persoon kiezen',
      setForAll: 'Voor alle {count} gelijke instellen',
      skipRow: 'Rij weglaten',
      leaveEmpty: 'Veld voor deze rij leeg laten',
      undo: 'Ongedaan maken',
      reason: {
        required: '{field} ontbreekt',
        missing: 'Een verplichte waarde ontbreekt',
        invalid: 'De waarde past niet',
        notFound: '{ref} niet gevonden',
        notFoundAny: 'Verwijzing niet gevonden',
        ambiguous: 'Verwijzing niet eenduidig',
        emailLinked: 'Dit e-mailadres hoort bij een login',
        general: 'Rij niet geïmporteerd',
        skipped: 'Rij weggelaten',
      },
      changes: '{count} wijziging genoteerd | {count} wijzigingen genoteerd',
      openRows: '{count} rij nog uit te zoeken | {count} rijen nog uit te zoeken',
      footer: {
        unchecked: '{changes} · {open}. Controleer eerst opnieuw, importeer dan.',
        withdrawn: 'Alle wijzigingen zijn ongedaan gemaakt. Controleer eerst opnieuw, importeer dan.',
        checked: '{open}. Je kunt ook nu importeren; deze rij blijft dan buiten. | {open}. Je kunt ook nu importeren; deze {count} blijven dan buiten.',
        clear: 'Alles is uitgezocht.',
      },
      back: 'Terug naar de vragen',
      recheck: 'Opnieuw controleren',
      commit: '{count} {things} importeren',
      truncated: {
        all: 'Toont {shown} van {total} rijen; alle {open} uit te zoeken rijen zijn erbij.',
        some: 'Toont {shown} van {open} uit te zoeken rijen — de rest staat in het foutenbestand.',
      },
      notice: {
        movedOn: 'De import is intussen verder gegaan. De pagina toont nu de huidige stand.',
        cell: 'Deze cel kan hier niet worden aangepast.',
        value: 'De waarde past niet.',
        generic: 'De wijziging kon niet worden opgeslagen.',
        notChecked: 'Er zijn wijzigingen die de controle nog niet heeft gezien. Controleer opnieuw en importeer dan.',
      },
      commitConfirmOpen: '{count} rij blijft buiten en komt daarna in een lijst. | {count} rijen blijven buiten en komen daarna in een lijst.',
    },
    // An import report's error row, worded from the facts the module sent (rowErrorText.ts).
    rowErrors: {
      required: '{field} is leeg, maar elke rij heeft er een waarde voor nodig.',
      unknownField: '{field} kan hier niet worden geïmporteerd.',
      invalidEnum: '‘{value}’ is geen geldige waarde voor {field}. Geldige waarden: {allowed}.',
      // With the review\'s handles: the cell holds the way out.
      invalidEnumCell: '‘{value}’ is geen geldige waarde voor {field}. Geldige waarden: {allowed}. Kies een toegestane waarde in de cel.',
      unresolved: {
        person: 'Geen persoon gevonden met {keys} ‘{value}’.',
        supervisor: 'Geen leidinggevende gevonden met {keys} ‘{value}’.',
        functionalSupervisor: 'Geen functioneel leidinggevende gevonden met {keys} ‘{value}’.',
        orgUnit: 'Geen org-eenheid gevonden met {keys} ‘{value}’.',
        parentOrgUnit: 'Geen bovenliggende org-eenheid gevonden met {keys} ‘{value}’.',
      },
      supervisorRequired: 'Geen leidinggevende gevonden met {keys} ‘{value}’, en deze persoon heeft er nog geen. Elke actieve persoon heeft er een nodig: importeer eerst de leidinggevende of kies er een die al bestaat.',
      unknownEntity: 'Dit soort gegevens kan hier niet worden geïmporteerd.',
      emailLinked: 'Deze persoon logt met dit e-mailadres in bij lumi, dus de import wijzigt het niet. Het adres blijft zoals het in de login staat – laat het veld voor deze rij leeg om de rest te importeren.',
      supervisorMissing: 'Elke actieve persoon heeft een leidinggevende nodig en deze persoon heeft er geen. Noem er een in het bestand of maak de leidinggevende eerst aan.',
      transformFailed: '‘{value}’ in kolom {field} kon niet worden omgezet. Controleer het formaat onder ‘Transformatie’ in de stap toewijzing.',
      transformFailedNoValue: 'Een waarde in kolom {field} kon niet worden omgezet. Controleer het formaat onder ‘Transformatie’ in de stap toewijzing.',
      unknown: 'Deze rij is niet geïmporteerd. De details staan in het foutenbestand.',
      skippedByUser: 'Je hebt deze rij weggelaten, dus ze wordt niet geïmporteerd.',
      requiredAny: 'In deze rij ontbreekt een verplichte waarde.',
      invalidEnumAny: 'Een waarde in deze rij hoort niet bij de toegestane waarden.',
      unknownFieldAny: 'Een veld in deze rij kan hier niet worden geïmporteerd.',
      unresolvedAny: 'Waarnaar deze rij verwijst, is niet gevonden. Maak het eerst aan of laat de rij weg.',
      unresolvedLocal: '{thing}: ‘{value}’ is niet gevonden. Maak het item eerst aan of laat de rij weg.',
      unresolvedUser: 'Er is geen passende persoon in deze workspace voor deze rij.',
      invalidTime: 'De tijden in deze rij passen niet bij elkaar.',
      invalidState: 'De status in deze rij bestaat niet in de gepubliceerde workflow.',
      stateChanged: 'De workflow is gewijzigd terwijl deze rij werd geïmporteerd. Controleer opnieuw.',
      invalidCustomValue: 'Een waarde voor een eigen veld in deze rij past niet.',
      ambiguous: {
        collision: '{ref}: ‘{value}’ past op twee verschillende records – op het ene als extern ID, op een ander als {other}. De import gokt niet: kies hieronder het juiste record.',
        otherSystem: '{ref}: ‘{value}’ is geen extern ID van dit bronsysteem maar van ‘{system}’ – en past ook op een record als {other}. De import gokt niet: importeer met bronsysteem ‘{system}’ als hetzelfde record bedoeld is, of kies hieronder het juiste record.',
        holderHasExternalId: '{ref}: ‘{value}’ past alleen als {other} – en dat record heeft in dit bronsysteem al het externe ID ‘{otherId}’. De import gokt niet: kies hieronder ‘{otherId}’ als dat record bedoeld is.',
      },
      // Without the review's handles (the completed report lists the row; nothing here can be chosen).
      ambiguousPlain: {
        collision: '{ref}: ‘{value}’ past op twee verschillende records – op het ene als extern ID, op een ander als {other}. De import gokt niet: maak de verwijzing in het bestand eenduidig.',
        otherSystem: '{ref}: ‘{value}’ is geen extern ID van dit bronsysteem maar van ‘{system}’ – en past ook op een record als {other}. De import gokt niet: importeer met bronsysteem ‘{system}’ als hetzelfde record bedoeld is, of maak de verwijzing eenduidig.',
        holderHasExternalId: '{ref}: ‘{value}’ past alleen als {other} – en dat record heeft in dit bronsysteem al het externe ID ‘{otherId}’. De import gokt niet: verwijs met ‘{otherId}’ als dat record bedoeld is.',
      },
      localRefs: {
        department: 'Afdeling',
        location: 'Locatie',
        candidate: 'Kandidaat',
        job: 'Vacature',
        client: 'Klant',
        project: 'Project',
        bookingType: 'Boekingstype',
        leaveType: 'Verlofsoort',
      },
      refs: {
        person: 'Persoon',
        supervisor: 'Leidinggevende',
        functionalSupervisor: 'Functioneel leidinggevende',
        orgUnit: 'Org-eenheid',
        parentOrgUnit: 'Bovenliggende org-eenheid',
      },
      supervisorInactive: {
        supervisor: 'De genoemde leidinggevende is niet meer actief en kan daarom niemand leiden.',
        functional: 'De genoemde functioneel leidinggevende is niet meer actief en kan daarom niemand leiden.',
      },
      supervisorUnconfirmed: {
        supervisor: 'De genoemde leidinggevende is nog niet door HR bevestigd en kan daarom niemand leiden. Bevestig hem of haar eerst in People.',
        functional: 'De genoemde functioneel leidinggevende is nog niet door HR bevestigd en kan daarom niemand leiden. Bevestig hem of haar eerst in People.',
      },
      datesInverted: 'De datum onder {end} ligt vóór die onder {start}.',
      agreementCodeInvalid: '{field} staat alleen letters, cijfers, ‘-’, ‘_’ en ‘.’ toe, hoogstens 60 tekens en zonder spaties.',
      statusTransition: 'Een contract kan niet van ‘{from}’ naar ‘{to}’ gaan.',
      reportingCycle: 'Deze toewijzing zou de rapportagelijn in een kring sluiten.',
      ambiguousOrgCode: 'Meerdere org-eenheden van verschillende soort hebben de code ‘{value}’. Verwijs met het externe ID naar de juiste.',
      keys: {
        externalId: 'extern ID',
        employeeNumber: 'personeelsnummer',
        code: 'code',
      },
    },
    list: {
      title: 'Eerdere imports',
      file: 'Bestand',
      system: 'Bronsysteem',
      status: 'Status',
      created: 'Aangemaakt',
      empty: 'Nog geen imports.',
      open: 'Openen',
      delete: 'Verwijderen',
      deleteConfirmTitle: 'Import verwijderen?',
      deleteConfirmBody: '“{file}” en alle bijbehorende importbestanden worden verwijderd. Al overgenomen gegevens blijven behouden.',
      deleted: 'Import “{file}” verwijderd.',
    },
  },
  dataExport: {
    title: 'HR Open-export',
    intro: 'Exporteert de gegevens van deze module als HR Open 4.5 (HR-JSON) — gevalideerd tegen de standaard.',
    create: 'Export aanmaken',
    creating: 'Wordt aangemaakt …',
    download: 'Downloaden',
    password: {
      title: 'ZIP-wachtwoord — alleen nu zichtbaar',
      hint: 'De export wordt gemaakt als wachtwoordbeveiligde ZIP (AES-256) omdat deze persoonsgegevens bevat. Kopieer het wachtwoord nu — het wordt niet opnieuw getoond. Openen met bijv. 7-Zip, WinZip of Keka.',
      copy: 'Wachtwoord kopiëren',
      copied: 'Gekopieerd',
    },
    empty: 'Nog geen exports.',
    columns: {
      standard: 'Standaard',
      status: 'Status',
      items: 'Records',
      created: 'Aangemaakt',
    },
    status: {
      queued: 'In wachtrij',
      generating: 'Wordt gegenereerd',
      completed: 'Afgerond',
      failed: 'Mislukt',
    },
  },
  // The demo's module picker (ADR 0083): the fork offers it on entry, the bar's
  // reset confirmation again. A locked module is booked (or core) and always in.
  // RoleNameTranslations.vue (ADR 0086): a custom role's names in other
  // languages, or the notice a system role gets instead.
  roleNames: {
    translations: 'Vertalingen',
    translationsHint: 'De naam in andere talen. Lege velden tonen de naam hierboven.',
    systemHint: 'Systeemrol: lumi geeft deze rol in elke taal een naam. Naam en beschrijving kunnen niet worden gewijzigd, de rechten wel.',
  },
  demoModules: {
    legend: 'Modules in de demo',
    booked: 'Geboekt — altijd inbegrepen',
  },
  demoStage: {
    label: 'Demo',
    viewingAs: 'Bekijken als',
    personaPlaceholder: 'Kies een rol',
    persona: {
      team_lead: 'Teamleider',
      employee: 'Medewerker',
      hr_admin: 'HR-beheerder',
      recruiter: 'Recruiter',
      ats_admin: 'ATS-beheerder',
      council_member: 'Lid van de ondernemingsraad',
      apprentice: 'Leerling',
      trainer: 'Praktijkopleider',
    },
    personaDoes: {
      team_lead: 'Beslist over verlof- en correctieverzoeken en beoordeelt sollicitaties.',
      employee: 'Boekt werkdagen, vraagt verlof aan en laat registraties corrigeren.',
      hr_admin: 'Maakt personen, projecten en vacatures aan.',
      recruiter: 'Brengt sollicitaties door de eerste screening en plant gesprekken.',
      ats_admin: 'Beslist over verlof, beoordeelt sollicitaties en maakt vacatures aan.',
      council_member: 'Brengt de stem van de ondernemingsraad uit over vacatures en aanbiedingen.',
      apprentice: 'Vinkt stappen af in het opleidingsplan en boekt werkdagen.',
      trainer: 'Beoordeelt rapporten van leerlingen en plant hun examens.',
    },
    picker: {
      title: 'Vanuit wiens oogpunt wil je de demo bekijken?',
      subtitle: '{count} collega’s bij {company}. Elke rol heeft eigen taken — je vinkjes blijven per rol bewaard.',
      taskCount: '{total} taak | {total} taken',
      current: 'Huidige weergave',
    },
    intro: {
      lead: 'is verzonnen. Ook de mensen erin zijn verzonnen. Alles onder de balk hoort bij de demo — daarin neem je verschillende rollen aan. Je echte account blijft onaangeraakt.',
      bridgeBefore: 'Je kunt de demo op elk moment beëindigen. Alle gegevens hieronder worden dan verwijderd en je kunt ',
      bridgeAfter: ' inrichten voor je eigen organisatie.',
      close: 'Sluiten',
    },
    reset: 'Demo resetten',
    guestMarker: 'Gast',
    guestWelcome: {
      invitedBy: 'Een collega van {workspace} heeft je uitgenodigd voor deze demo.',
      invitedAnon: 'Een collega heeft je uitgenodigd voor deze demo.',
      body: '{company} is verzonnen en wordt gedeeld met iedereen in deze demo. Anderen hebben misschien al dingen geprobeerd, dus het kan er half gebruikt uitzien. “{reset}” geeft iedereen een frisse start. Je toegang eindigt als de demo eindigt. Ook de mensen erin zijn verzonnen.',
    },
    cancel: 'Annuleren',
    rebuildFailed: 'De demo kon niet opnieuw worden opgebouwd. Probeer het opnieuw.',
    resetConfirm: {
      title: 'Demo resetten?',
      body: 'Alles wat {company} nu bevat wordt weggegooid — ook wat jij of je collega’s hebben ingevoerd, en ieders voortgang op de routes — en de demo wordt opnieuw opgebouwd. Iedereen in de demo begint opnieuw; niemands toegang verandert.',
      cta: 'Demo resetten',
    },
    // The demo bar's "Invite a colleague" dialog (issue 669).
    guests: {
      entry: 'Collega uitnodigen',
      title: 'Collega uitnodigen',
      subtitle: 'Collega’s die je uitnodigt zien deze demo zoals hij is en kunnen hem zelf uitproberen.',
      close: 'Sluiten',
      loading: 'Laden…',
      retry: 'Opnieuw proberen',
      emailLabel: 'Zakelijk e-mailadres',
      emailPlaceholder: "naam{'@'}bedrijf.nl",
      send: 'Uitnodiging versturen',
      sendAgain: 'Opnieuw versturen',
      slotsLeft: '{count} plek vrij | {count} plekken vrij',
      exhausted: 'Alle {limit} plekken zijn bezet. Trek hieronder een uitnodiging in om iemand anders uit te nodigen.',
      invalid: 'Voer een geldig e-mailadres in.',
      listTitle: 'In deze demo naast jou',
      used: '{used} van {limit} bezet',
      empty: 'Nog niemand uitgenodigd.',
      state: {
        invited: 'Uitgenodigd',
        joined: 'Toegetreden',
      },
      revoke: 'Intrekken',
      revoking: 'Intrekken…',
      revokeFor: 'Toegang van {email} intrekken',
      about: {
        title: 'Wat een gast is',
        sees: 'Een gast ziet deze demo precies zoals hij nu is — ook alles wat jij al hebt geprobeerd. “{reset}” in de balk geeft iedereen een frisse start.',
        resets: 'Een gast kan de demo ook resetten — voor iedereen in de demo.',
        limits: 'Een gast kan de demo nooit beëindigen en nooit je echte werkruimte aanraken.',
        ends: 'Gasten worden verwijderd zodra de demo eindigt.',
      },
      feedback: {
        sent: 'Uitnodiging verstuurd naar {email}.',
        resent: 'Uitnodiging opnieuw verstuurd naar {email}.',
        undelivered: 'De e-mail aan {email} kon niet worden bezorgd. {email} staat op de lijst en bezet een plek — verstuur de uitnodiging opnieuw om het nog eens te proberen.',
        revoked: 'De toegang van {email} is ingetrokken. De plek is weer vrij.',
        alreadyMember: '{email} heeft al toegang tot deze workspace.',
        limit: 'Alle plekken zijn bezet. Trek een uitnodiging in om iemand anders uit te nodigen.',
        rateLimited: 'Te veel uitnodigingen vandaag. Probeer het later opnieuw.',
        notLive: 'Uitnodigen kan alleen zolang de demo actief is. De demo wordt opnieuw opgebouwd of de inrichting is gestart — probeer het opnieuw zodra de demo terug is.',
        operator: 'Je bent ingelogd als systeembeheerder. Systeembeheerders kunnen geen collega’s uitnodigen in de demo van een klant.',
        operatorNotMember: '{email} hoort bij een lumi-operatoraccount, dat niet kan deelnemen aan de demo van een klant. Nodig een ander adres uit.',
        notAPerson: '{email} hoort bij een account dat geen persoon is, zoals een serviceaccount. Nodig het eigen werkmailadres van een collega uit.',
        forbidden: 'Alleen de workspace-eigenaar of een suite-beheerder kan collega’s uitnodigen.',
        noticeIncomplete: 'Uitnodigingen zijn gepauzeerd totdat de kennisgevingen voor medewerkers onder Juridische kennisgevingen volledig zijn ingevuld.',
        accountClosed: 'Dat account is gesloten en kan niet worden uitgenodigd.',
        unavailable: 'Uitnodigingen kunnen nu niet worden geteld. Probeer het zo meteen opnieuw.',
        revokeFailed: 'De toegang van {email} kon niet worden ingetrokken. Probeer het opnieuw.',
        generic: 'Er is iets misgegaan. Probeer het opnieuw.',
      },
    },
    leave: 'Demo beëindigen',
    continueSetup: 'Installatie voortzetten',
    menu: 'Demo-acties',
    signOut: 'Afmelden',
    logoutHint: 'Tijdens de demo meld je je af via de deur of het menu in de demobalk.',
    journey: {
      title: 'De route van {name}',
      count: '{done} van {total} gedaan',
      refresh: 'Route vernieuwen',
      unknown: 'Sommige controles waren niet bereikbaar – de laatst bekende stand wordt getoond.',
      yay: 'Dat was de hele route van {name} – goed gedaan.',
      bridgeAdmin: 'Je hebt elke route doorlopen. Als je zover bent, beëindig je de demo en richt je je eigen werkruimte in.',
      bridgeUser: 'Je hebt elke route doorlopen. Een beheerder kan de demo beëindigen en jullie werkruimte inrichten.',
      blockedReset: 'Een reset brengt het terug:',
      blocked: {
        gone: 'Wat deze taak nodig heeft, is weg.',
      },
      next: 'Als volgende',
      nextCta: 'Openen in {module}',
      footer: 'De demo vinkt af wat je doet.',
    },
  },
  // The shared notifications popover (NotificationsPopover.vue). Its own namespace: the
  // apps' `notifications.*` keys (inbox page, preferences) are theirs and stay put.
  notificationsPopover: {
    title: 'Meldingen',
    empty: 'Je bent helemaal bij.',
    markAllRead: 'Alles als gelezen markeren',
    markRead: 'Markeren als gelezen',
    markUnread: 'Markeren als ongelezen',
    loading: 'Laden…',
    openTarget: 'Open het gekoppelde item',
    goToAll: 'Naar meldingen',
  },
  // The shared place search (PlacePicker.vue). `noMatchAdd` is the wording for hosts whose
  // typed text IS the name (Enter adds it as typed); `noMatch` for hosts that keep it beside the field.
  placePicker: {
    placeholder: 'Zoek een stad of gemeente …',
    keptHint: 'Wordt opgeslagen zoals je het hebt getypt — zonder gekoppelde plaats.',
    searching: 'Bezig met zoeken …',
    typeMore: 'Typ minstens {count} tekens',
    noMatch: 'Geen resultaat — je tekst blijft staan',
    error: 'Zoeken mislukt',
    rateLimited: 'Te veel zoekopdrachten — we proberen het zo opnieuw',
    resultsAnnouncement: 'Geen resultaten | 1 resultaat | {count} resultaten',
    clear: 'Plaats verwijderen',
    noMatchAdd: 'Geen plaats gevonden — Enter voegt de naam toe zoals getypt',
  },
  // The suite's five app names and their one-line launcher descriptions, in this
  // language. THE one copy: component-lib's registry carries no displayed string, and
  // every app merges this underneath its own messages (ADR 0026 section 7).
  lumiModules: {
    suite: {
      name: 'Home',
      description: 'Jouw overzicht van de werkplek',
    },
    ats: {
      name: 'Werving',
      description: 'Vacatures, sollicitaties en het wervingsproces',
    },
    time: {
      name: 'Tijd',
      description: 'Tijdregistratie, werktijdrekeningen en goedkeuringen',
    },
    people: {
      name: 'Personeel',
      description: 'Personeelsdossiers, afdelingen en locaties',
    },
    apprentice: {
      name: 'Leerlingen',
      description: 'Digitale opleidingsboekjes en opleidingsplannen',
    },
  },
};
